import { ConditionNode, PaneTypes } from "@unlikelyai-magic/shared/data-access/api";

export enum UpdateType {
  PRE_EVALUATED = "PRE_EVALUATED",
  PRE_EVALUATED_OVERRIDDEN = "PRE_EVALUATED_OVERRIDDEN",
  REPHRASING = "REPHRASING",
  SPLIT_OUT = "SPLIT_OUT",
}

export interface UpdatedNodeBase {
  node_name: string;
  update_type: UpdateType;
  explanation: string;
}

export interface PreEvaluatedNode extends UpdatedNodeBase {
  update_type: UpdateType.PRE_EVALUATED;
  node_value: string;
  outcome: string;
}

export interface PreEvaluatedOverriddenNode extends UpdatedNodeBase {
  update_type: UpdateType.PRE_EVALUATED_OVERRIDDEN;
  original_node_value: string;
  node_value: string;
  note?: string;
  outcome: string;
}

export interface RephrasingNode extends UpdatedNodeBase {
  update_type: UpdateType.REPHRASING;
  original: string;
  rephrased: string;
  outcome: string;
}

export interface SplitOutNode extends UpdatedNodeBase {
  update_type: UpdateType.SPLIT_OUT;
  source_node: string;
  original: string;
  rephrased: string;
}

export type UpdatedNode =
  | PreEvaluatedNode
  | PreEvaluatedOverriddenNode
  | RephrasingNode
  | SplitOutNode;

export interface AnnotatedTree {
  tree: ConditionNode;
  updatedNodes: UpdatedNode[];
}

export interface GuardrailEditDataResponse {
  ingestedTrees: PaneTypes[];
  annotatedTree: AnnotatedTree;
  guardrailTree: ConditionNode;
}

/**
 * Response from the new document-based endpoint.
 * Returns a dictionary mapping guardrail names to their edit data.
 */
export interface GuardrailEditDataByDocumentResponse {
  data: Record<string, GuardrailEditDataResponse>;
}
